import * as React from "react";
const FieldGroup = ({ onSelect, selected, group, title, children = void 0 }) => /* @__PURE__ */ React.createElement(
  "a",
  {
    onClick: () => onSelect(group),
    role: "button",
    style: { fontWeight: selected ? "bold" : "normal" },
    tabIndex: 0,
    title
  },
  children
);
export default FieldGroup;
